// Google Analytics event tracking utilities
/* global gtag */

// Track new conversation created
export const trackNewConversation = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'new_conversation', {
      event_category: 'user_interaction',
      event_label: 'conversation_created'
    });
  }
};

// Track chat deleted
export const trackDeletedChat = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'deleted_chat', {
      event_category: 'user_interaction',
      event_label: 'chat_deleted'
    });
  }
};

// Track sidebar opened
export const trackSidebarOpen = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'sidebar_open', {
      event_category: 'ui_interaction',
      event_label: 'sidebar_opened'
    });
  }
};

// Track sidebar closed
export const trackSidebarClose = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'sidebar_close', {
      event_category: 'ui_interaction',
      event_label: 'sidebar_closed'
    });
  }
};

// Track new message from user (not AI responses)
export const trackNewMessage = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'new_message', {
      event_category: 'user_interaction',
      event_label: 'message_sent'
    });
  }
};